import { Protocol } from './index';
import { Category } from '../constants';

const nft: Protocol[] = [
  {
    name: 'Anotherblock',
    url: 'https://anotherblock.io/',
    logoPath: '/logos/anotherblock.jpg',
    category: Category.NFT,
    twitterUrl: 'https://twitter.com/anotherblock_io',
  },
  {
    name: 'Coinvise',
    url: 'https://coinvise.co/',
    logoPath: '/logos/coinvise.jpg',
    category: Category.NFT,
    twitterUrl: 'https://twitter.com/CoinviseCo',
  },
  {
    name: 'Collectify',
    url: 'https://collectify.app/',
    logoPath: '/logos/collectify.jpg',
    category: Category.NFT,
    twitterUrl: 'https://twitter.com/Collectify_app',
  },
  {
    name: 'Crossmint',
    url: 'https://crossmint.com/',
    logoPath: '/logos/crossmint.jpg',
    category: Category.NFT,
    twitterUrl: 'https://twitter.com/crossmint',
  },
  {
    name: 'Decent',
    url: 'https://decent.xyz/',
    logoPath: '/logos/decent.jpg',
    category: Category.NFT,
    twitterUrl: 'https://twitter.com/decentxyz',
  },
  {
    name: 'Mint Sniper',
    url: 'https://mintsniper.com/',
    logoPath: '/logos/mint_sniper.png',
    category: Category.NFT,
    twitterUrl: 'https://twitter.com/mintsniperapp',
  },
  {
    name: 'Opensea',
    url: 'https://opensea.io/',
    logoPath: '/logos/opensea.jpg',
    category: Category.NFT,
    twitterUrl: 'https://twitter.com/opensea',
  },
  {
    name: 'Reservoir',
    url: 'https://reservoir.tools/',
    logoPath: '/logos/reservoir.jpg',
    category: Category.NFT,
    twitterUrl: 'https://twitter.com/reservoir0x',
  },
  {
    name: 'Singular',
    url: 'https://singular.app/',
    logoPath: '/logos/singular.jpg',
    category: Category.NFT,
    twitterUrl: 'https://twitter.com/rmrkapp',
  },
  {
    name: 'Unlock Protocol',
    url: 'https://unlock-protocol.com/',
    logoPath: '/logos/unlock_protocol.jpg',
    category: Category.NFT,
    twitterUrl: 'https://twitter.com/UnlockProtocol',
  },
];

export { nft };
